export const HELP_GUIDE_PATH = '/help';

export const HELP_GUIDE_SECTIONS = Object.freeze({
    BEFORE_YOU_BEGIN: 'before-you-begin',
    WORKFLOW_OVERVIEW: 'workflow-overview',
    PREPARE_DATA: 'prepare-scan-data',
    INPUT_SCAN_DATA: 'step-1-input-scan-data',
    CHOOSE_REPORTS: 'step-2-choose-reports',
    CUSTOMIZE_REPORTS: 'review-and-customize-report-queue',
    GENERATE_REPORTS: 'step-3-generate-reports',
    REVIEW_RESULTS: 'find-review-and-export-results',
    TROUBLESHOOTING: 'troubleshooting',
});

export const HELP_GUIDE_SECTION_IDS = Object.freeze(
    Object.values(HELP_GUIDE_SECTIONS)
);

export const CONTEXTUAL_HELP_SECTIONS = Object.freeze({
    INPUT_PREPARATION: HELP_GUIDE_SECTIONS.PREPARE_DATA,
    INPUT_REVIEW: HELP_GUIDE_SECTIONS.INPUT_SCAN_DATA,
    REPORT_SELECTION: HELP_GUIDE_SECTIONS.CHOOSE_REPORTS,
    REPORT_QUEUE: HELP_GUIDE_SECTIONS.CUSTOMIZE_REPORTS,
    GENERATION: HELP_GUIDE_SECTIONS.GENERATE_REPORTS,
    RESULTS: HELP_GUIDE_SECTIONS.REVIEW_RESULTS,
    REPORT_TROUBLESHOOTING: HELP_GUIDE_SECTIONS.TROUBLESHOOTING,
});

export const getHelpGuideHref = (sectionId) => (
    HELP_GUIDE_SECTION_IDS.includes(sectionId)
        ? `${HELP_GUIDE_PATH}#${sectionId}`
        : HELP_GUIDE_PATH
);
